<template>
  <div class="px-5 py-4 pt-10" v-if="!loading && academy">
    <div class="pb-4 flex justify-space-between">
      <div>
        <div class="flex items-center" style="gap:0.5rem;">
          <img class="header-icon" :src="require('@/assets/icons/products_and_memberships.svg')" />
          <div style="font-size:1.438rem;">{{ $t("message.products_memberships_plus.title") }}</div>HERE
        </div>
        <div class="page-subtitle">{{ $t("message.products_memberships_plus.title_explained") }}</div>
      </div>
      <div class="flex flex-grow-0" style="gap:1.25rem;">
        <PlusButton small intent="primary" @click="navigateTo({ name: 'bulksellplus' })">
          {{ $t("message.products_memberships_plus.sell_items") }}</PlusButton>
        <v-menu offset-y small>
          <template v-slot:activator="{ on }">
            <v-btn class="rounded" style="border:1px solid #BDBDBD;" v-on="on" fab text small slot="activator" left>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item v-allowed="'add_products'"
              @click="navigateTo({ name: 'manageproductplus', params: { productId: 'new' } })">
              <v-list-item-title>
                <span class="mb-3 mr-1">
                  <v-icon size="20">mdi-view-grid-plus-outline</v-icon>
                </span>
                {{ $t("message.add_product") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item v-if="paymentsReady" v-allowed="'add_products'"
              @click="navigateTo({ name: 'managepromocodesplus' })">
              <v-list-item-title>
                <span class="mb-3 mr-1">
                  <ReceiptTaxIcon size="20" class="hero-icon"></ReceiptTaxIcon>
                </span>
                {{ $t("message.promo_codes") }}
              </v-list-item-title>
            </v-list-item>

            <v-list-item v-allowed="'sell_items'" @click="navigateTo({ name: 'sellamount' })">
              <v-list-item-title>
                <span class="mb-3 mr-1">
                  <v-icon size="20">mdi-currency-usd</v-icon>
                </span>
                {{ $t("message.sell_amount") }}
              </v-list-item-title>
            </v-list-item>

            <v-list-item v-if="hasProducts" v-allowed="'sell_items'" @click="navigateTo({ name: 'bulksellplus' })">
              <v-list-item-title>
                <span class="mb-3 mr-1">
                  <v-icon size="20">mdi-cart-outline</v-icon>
                </span>
                {{ $t("message.sell_multiple_items") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item v-if="hasProducts" v-allowed="'sell_items'" @click="getProductsCSV()">
              <v-list-item-title>
                <span class="mb-3 mr-1">
                  <CloudDownloadIcon size="20" class="hero-icon"></CloudDownloadIcon>
                </span>
                {{ $t("message.download_inventory") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item v-if="isConnected" v-allowed="'sell_items'" @click="navigateTo({ name: 'publicmemberships' })">
              <v-list-item-title>
                <BookmarkAltIcon size="20" class="hero-icon"></BookmarkAltIcon>
                {{ $t("message.memberships_pubic_access") }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
    <v-divider />
    <div class="pt-8">
      <div class="flex">
        <v-tabs v-model="activeTab" slider-color="plusIndigoDarken1" color="plusTabActiveText" class="font-roboto">
          <v-tab key="products" @click="clickTab(0)">{{ $t("message.products_memberships_plus.products_tab") }}</v-tab>
          <v-tab key="memberships"
            @click="clickTab(1)">{{ $t("message.products_memberships_plus.memberships_tab") }}</v-tab>
          <v-tab key="packages" @click="clickTab(2)">{{ $t("message.products_memberships_plus.packages_tab") }}</v-tab>
        </v-tabs>
        <div class="flex rounded py-2 px-3 align-center currency-widget" style="gap:0.5rem;">
          <div class="plusLightGreenLighten5 rounded" style="padding:5px;">
            <v-icon size="28" color="plusGreenDarken4"
              style="margin-top:-8px;transform: scaleX(-1);">mdi-cash-multiple</v-icon>
          </div>
          <div class="flex flex-col">
            <div class="plusTextPrimary--text" style="font-size:0.75rem;">{{ $t("message.currency") }}</div>
            <div class="plusTextPrimary--text text-no-wrap" style="font-size:0.875rem;">{{ `${academy.currency}
              (${academy.currencySymbol})` }}</div>
          </div>

        </div>
      </div>
      <div class="pt-6">
        <v-autocomplete v-if="trendline.products.length > 0" @change="getProductTrendline()" v-model="selectedProduct"
          :items="trendline.products" :placeholder="$t('message.select_view_trendline')" item-text="text"
          item-value="value" clearable outlined dense></v-autocomplete>
        <v-card-text v-if="selectedProduct">
          <v-skeleton-loader v-if="trendline.loading" type="image">
          </v-skeleton-loader>
          <div v-else>
            <div v-if="trendline.data.length > 0">
              <ApexChart type="area" :options="trendline.options" height="300" :series="trendline.data"></ApexChart>
            </div>
            <div v-else class="text-center text-h6">
              {{ $t('message.no_data') }}
            </div>
          </div>
        </v-card-text>
      </div>
      <v-tabs-items v-model="activeTab">
        <v-tab-item key="products">
          <div v-if="goods.length === 0" class="pt-16">
            <div class=" font-roboto flex flex-col align-center" style="gap:3rem;">
              <div class="flex flex-col align-center">
                <div class="py-5">
                  <div class="empty-state-icon">
                    <img :src="require('@/assets/icons/products.svg')" />
                  </div>
                </div>
                <div class="plusGreyLighten1--text" style="font-size:1.25rem;">
                  {{ $t("message.products_memberships_plus.no_products_yet") }}</div>
                <div class="plusGreyLighten1--text" style="font-size:1.25rem;">
                  {{ $t("message.products_memberships_plus.add_your_first_product") }}</div>
              </div>
              <PlusButton intent="primary"
                @click="navigateTo({ name: 'manageproductplus', params: { productId: 'new' } })">
                {{ $t("message.products_memberships_plus.add_product") }}</PlusButton>
            </div>
          </div>
          <div v-if="goods.length > 1" class="rounded plusGreyLighten5" style="padding:1rem;">
            <v-text-field outlined dense :label="$t('message.filter_products')" v-model="filterProductsValue" clearable
              hide-details></v-text-field>
          </div>
          <v-expansion-panels class="pt-4" multiple flat v-if="categorizedGoods" v-model="selectedCategory">
            <v-expansion-panel v-for="(category, index1) in filteredCategories" :key="'category_' + index1"
              :value="false">
              <v-expansion-panel-header @click="clickCategory(index1)">
                <div>
                  {{ category == "uncategorized" ? $t("message.uncategorized") : category }}
                  ({{ categorizedGoods[category] ? categorizedGoods[category].length : 0 }})
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-list v-if="categorizedGoods[category].length > 0">
                  <template v-for="(i, index2) in categorizedGoods[category]">
                    <v-list-item class="px-0" :key="'category_item_' + index1 + index2" link @click="doNothing()">
                      <v-list-item-avatar @click="navigateTo({
                        name: 'manageproduct',
                        params: { productId: i._id },
                      })">
                        <v-badge v-if="i.type == 'good' && i.color" bordered bottom size="50" :color="i.color"
                          offset-x="35" offset-y="15">
                          <v-avatar size="50" color="grey lighten-4">
                            <ImageDisplay v-if="i.image" :src="i.image" />
                            <img v-else :src="assets('logo-circular-watermarked.png')" />
                          </v-avatar>
                        </v-badge>
                        <v-avatar v-else size="50" color="grey lighten-4">
                          <ImageDisplay v-if="i.image" :src="i.image" />
                          <img v-else :src="assets('logo-circular-watermarked.png')" />
                        </v-avatar>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title style="font-size: 14px;">
                          <span class="text-subtitle-1 ml-r">
                            {{ academy.currencySymbol + i.amountDecimal }}
                          </span>
                          <span class="gray--text">{{ i.name }}</span>
                          <v-tooltip v-if="i.taxBehavior" bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <ReceiptTaxIcon v-bind="attrs" v-on="on" size="20" class="hero-icon"
                                :color="themeColor('accent')"></ReceiptTaxIcon>
                            </template>
                            <span>{{ $t("message.taxes_enabled") }}</span>
                          </v-tooltip>
                          <v-tooltip v-if="i.altStripeAccount" bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on" size="20" color="accent">mdi-bank-transfer</v-icon>
                            </template>
                            <span>{{ $t("message.alternative_stripe_account") }}</span>
                          </v-tooltip>
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          <span class="mr-1" v-if="i.size">{{ $t("message.size") }}: {{ i.size }}</span>
                          <span class="text-caption" v-if="i.availableQuantity != null && !i.unlimited"
                            :style="'color:' + getInventoryColor(i.availableQuantity)">
                            ({{ i.availableQuantity }}
                            {{ $t("message.available") }})
                          </span>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-menu offset-y>
                          <template v-slot:activator="{ on }">
                            <v-btn class="rounded" style="border:1px solid #BDBDBD;" v-on="on" fab text small
                              slot="activator" left>
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item v-allowed="'edit_products'" @click.stop="
                              navigateTo({
                                name: 'manageproductplus',
                                params: { productId: i._id },
                              })
                              ">
                              <v-list-item-title>
                                <PencilAltIcon size="20" color="gray" class="hero-icon-button"></PencilAltIcon>
                                {{ $t("message.edit") }}
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item v-allowed="'sell_items'" v-if="
                              i.unlimited ||
                              !i.hasOwnProperty('availableQuantity') ||
                              i.availableQuantity == null ||
                              (i.availableQuantity && i.availableQuantity > 0)
                            " @click.stop="
                              navigateTo({
                                name: 'sellproduct',
                                params: { productId: i._id },
                              })
                              ">
                              <v-list-item-title>
                                <v-icon size="20" class="mr-1">mdi-currency-usd
                                </v-icon>
                                {{ $t("message.sell") }}
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="isConnected && i.amountDecimal > 0" v-allowed="'sell_items'"
                              @click.stop="openQRCode(i._id)">
                              <v-list-item-title>
                                <QrcodeIcon size="20" color="gray" class="hero-icon-button"></QrcodeIcon>
                                {{ $t("message.print_qr_code") }}
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider v-if="index2 != categorizedGoods[category].length - 1"
                      :key="'category_item_divier' + index1 + index2"></v-divider>
                  </template>
                </v-list>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-tab-item>
        <v-tab-item key="memberships">
          <div v-if="memberships.length === 0 && filteredSubscriptions.length === 0" class="pt-16">
            <div class="flex flex-col align-center" style="gap:3rem;">
              <div class="flex flex-col align-center">
                <div class="py-5">
                  <div class="empty-state-icon">
                    <img :src="require('@/assets/icons/memberships.svg')" />
                  </div>
                </div>
                <div class="plusGreyLighten1--text" style="font-size:1.25rem;">
                  {{ $t("message.products_memberships_plus.no_memberships_yet") }}</div>
                <div class="plusGreyLighten1--text" style="font-size:1.25rem;">
                  {{ $t("message.products_memberships_plus.create_your_first_membership") }}</div>
              </div>
              <PlusButton intent="primary"
                @click="navigateTo({ name: 'manageproductplus', params: { productId: 'new' } })">
                Add Membership</PlusButton>
            </div>
          </div>
          <v-expansion-panels v-if="memberships.length > 0 || filteredSubscriptions.length > 0" flat
            v-model="selectedMembershipType">
            <v-expansion-panel :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'">
              <v-expansion-panel-header>
                <div class="flex items-center">
                  <v-icon class="mr-1">mdi-wallet-membership</v-icon>
                  <span v-if="paymentsReady">{{ $t("message.manual") }}</span>
                  <span v-else>{{ $t("message.memberships") }} </span>
                  &nbsp;({{ memberships.length }})
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-list two-line dense class="text-left mt-2">
                  <template v-for="(i, index) in memberships">
                    <v-list-item class="py-6" :key="'membership_' + index" @click="doNothing()">
                      <v-list-item-content>
                        <h5>
                          {{ i.name }}
                        </h5>
                        <v-list-item-subtitle>
                          <v-tooltip v-if="i.taxBehavior" bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <ReceiptTaxIcon v-bind="attrs" v-on="on" size="20" class="hero-icon"
                                :color="themeColor('accent')"></ReceiptTaxIcon>
                            </template>
                            <span>{{ $t("message.taxes_enabled") }}</span>
                          </v-tooltip>
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="mb-1">
                          {{ i.amountDecimal }} {{ academy.currency }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <div v-if="!isSmallerDisplay()" class="flex" style="gap:1.25rem;">
                          <PlusButton @click.stop="navigateTo({ name: 'manageproductplus', params: { productId: i._id } })">
                            <div class="flex align-center" style="gap:0.5rem;">
                              <v-icon size="20">mdi-pencil-outline</v-icon>
                              <div>{{ $t("message.edit") }}</div>
                            </div>
                          </PlusButton>
                          <PlusButton @click.stop="navigateTo({ name: 'sellproductplus', params: { productId: i._id } })">
                            <div class="flex align-center" style="gap:0.5rem;">
                              <v-icon size="20">mdi-tag-outline</v-icon>
                              <div>{{ $t("message.products_memberships_plus.sell_membership") }}</div>
                            </div>
                          </PlusButton>
                        </div>
                        <v-menu v-else offset-y>
                          <template v-slot:activator="{ on }">
                            <v-btn class="rounded" style="border:1px solid #BDBDBD;" v-on="on" fab text small>
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>
                          <v-list dense>
                            <v-list-item @click.stop="navigateTo({ name: 'manageproductplus', params: { productId: i._id } })">
                              <v-list-item-title>
                                <v-icon size="18" class="mr-1">mdi-pencil-outline</v-icon>
                                {{ $t("message.edit") }}
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item @click.stop="navigateTo({ name: 'sellproductplus', params: { productId: i._id } })">
                              <v-list-item-title>
                                <v-icon size="18" class="mr-1">mdi-tag-outline</v-icon>
                                {{ $t("message.products_memberships_plus.sell_membership") }}
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider v-if="index + 1 < subscriptions.length" :key="index"></v-divider>
                  </template>
                </v-list>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel v-if="paymentsReady"
              :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'">
              <v-expansion-panel-header>
                <div>
                  <v-icon class="mr-1">mdi-auto-mode</v-icon>
                  {{ $t("message.automatic") }} ({{ filteredSubscriptions.length }})
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-list two-line dense class="text-left mt-2" v-if="paymentsReady">
                  <v-card-text v-if="!isConnected">
                    <h3>{{ $t("message.need_connect_stripe_subscriptions") }}</h3>
                  </v-card-text>
                  <v-list-item v-if="isConnected">
                    <v-list-item-action>
                      <v-icon>mdi-tune-vertical</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        <span v-if="academyBillDay">
                          {{ $t("message.academy_bill_day") }}: <b>{{ academyBillDay }}</b>
                        </span>
                        <span v-else>{{ $t("message.no_academy_bill_day") }}</span>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        {{ $t("message.academy_bill_day_explianed") }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn text small>
                        <v-icon @click="showEditBillDayDialog()">mdi-square-edit-outline</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                  <template v-for="(i, index) in filteredSubscriptions">
                    <v-list-item class="py-6" :key="'subscription_' + index" @click="doNothing()">
                      <v-list-item-content>
                        <h5>
                          {{ i.name }}
                          <v-tooltip v-if="i.taxBehavior" bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on" size="20"
                                color="accent">mdi-label-percent-outline</v-icon>
                            </template>
                            <span>{{ $t("message.taxes_enabled") }}</span>
                          </v-tooltip>
                          <v-tooltip v-if="i.altStripeAccount" bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on" size="20" color="accent">mdi-bank-transfer</v-icon>
                            </template>
                            <span>{{ $t("message.alternative_stripe_account") }}</span>
                          </v-tooltip>
                        </h5>
                        <v-list-item-subtitle class="mb-1 mt-1">
                          <span><b>{{ academy.currencySymbol }}{{ i.amountDecimal }}</b></span>
                          {{ getIntervalDisplay(i.interval, i.customDaysInterval) }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <div v-if="!isSmallerDisplay()" class="flex" style="gap:1.25rem;">
                          <PlusButton @click.stop="
                            navigateTo({
                              name: 'manageproductplus',
                              params: { productId: i._id },
                            })
                            ">
                            <div class="flex align-center" style="gap:0.5rem;">
                              <v-icon size="20">mdi-pencil-outline</v-icon>
                              <div>{{ $t("message.edit") }}</div>
                            </div>
                          </PlusButton>
                          <PlusButton @click.stop="
                            navigateTo({
                              name: 'sellproductplus',
                              params: { productId: i._id },
                            })
                            ">
                            <div class="flex align-center" style="gap:0.5rem;">
                              <v-icon size="20">mdi-tag-outline</v-icon>
                              <div>{{ $t("message.products_memberships_plus.sell_membership") }}</div>
                            </div>
                          </PlusButton>
                        </div>
                        <v-menu v-else offset-y>
                          <template v-slot:activator="{ on }">
                            <v-btn class="rounded" style="border:1px solid #BDBDBD;" v-on="on" fab text small>
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>
                          <v-list dense>
                            <v-list-item @click.stop="
                              navigateTo({
                                name: 'manageproductplus',
                                params: { productId: i._id },
                              })
                              ">
                              <v-list-item-title>
                                <v-icon size="18" class="mr-1">mdi-pencil-outline</v-icon>
                                {{ $t("message.edit") }}
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item @click.stop="
                              navigateTo({
                                name: 'sellproductplus',
                                params: { productId: i._id },
                              })
                              ">
                              <v-list-item-title>
                                <v-icon size="18" class="mr-1">mdi-tag-outline</v-icon>
                                {{ $t("message.products_memberships_plus.sell_membership") }}
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider v-if="index + 1 < subscriptions.length" :key="index"></v-divider>
                  </template>
                </v-list>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-tab-item>
        <v-tab-item key="packages">
          <div class="flex justify-end" v-if="packages.length > 0">
            <PlusButton @click="addPackageDialog = true; newAcademyPackage = {}">
              {{ $t("message.products_memberships_plus.add_package") }}</PlusButton>
          </div>
          <div v-if="packages.length === 0" class="pt-16">
            <div class="flex flex-col align-center" style="gap:3rem;">
              <div class="flex flex-col align-center">
                <div class="py-5">
                  <div class="empty-state-icon">
                    <img :src="require('@/assets/icons/packages.svg')" />
                  </div>
                </div>
                <div class="plusGreyLighten1--text" style="font-size:1.25rem;">
                  {{ $t("message.products_memberships_plus.no_packages_yet") }}</div>
                <div class="plusGreyLighten1--text" style="font-size:1.25rem;">
                  {{ $t("message.products_memberships_plus.create_your_first_package") }}</div>
              </div>
              <PlusButton intent="primary" @click="addPackageDialog = true; newAcademyPackage = {}">
                {{ $t("message.products_memberships_plus.add_package") }}</PlusButton>
            </div>
          </div>
          <v-list dense v-if="packages.length > 0">
            <template v-for="(i, index) in packages">
              <v-list-item :key="'products_package_' + index" @click="goToPackage(i)">
                <v-list-item-content>
                  <v-list-item-title>
                    {{ i.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>{{ i.description }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" class="px-1 py-5" style="border:1px solid #BDBDBD;" text small slot="activator"
                        left>
                        <v-icon size="20">mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click.stop="goToPackage(i)">
                        <v-list-item-title>
                          <PencilAltIcon color="gray" class="hero-icon-button"></PencilAltIcon>
                          {{ $t("message.edit") }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item @click.stop="
                        navigateTo({
                          name: 'sellproductplus',
                          params: { productId: 'package' },
                          query: { packageId: i._id }
                        })
                        ">
                        <v-list-item-title>
                          <v-icon class="mr-1">mdi-currency-usd</v-icon>
                          {{ $t("message.sell") }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list-item-action>
              </v-list-item>
              <v-divider v-if="index + 1 < subscriptions.length" :key="index"></v-divider>
            </template>
          </v-list>
        </v-tab-item>
      </v-tabs-items>
    </div>
    <v-dialog v-model="addPackageDialog" width="90%">
      <v-card style="padding:3rem !important;">
        <div class="flex flex-col" style="0.5rem;">
          <div class="plusGreyDarken4--text" style="font-size:1.438rem;">
            {{
              $t("message.add_package")
            }}
          </div>
          <div class="plusGreyDarken2--text">{{ $t("message.products_memberships_plus.add_package_explained") }}</div>
        </div>
        <div class="pt-6">
          <v-text-field outlined dense :label="$t('message.name')" v-model="newProductsPackage.name"></v-text-field>
          <v-text-field outlined dense :label="$t('message.description')"
            v-model="newProductsPackage.description"></v-text-field>
          <v-autocomplete return-object @change="selectMainPackageProduct" v-model="newProductsPackage.mainProduct"
            :items="availableProductsForMain" item-text="name" :label="$t('message.main_product')" item-value="_id"
            clearable outlined dense></v-autocomplete>
          <v-select outlined multiple :label="$t('message.add_more_products')" dense :items="availableProductsForExtra"
            v-model="newProductsPackage.products"></v-select>
        </div>
        <div class="flex" style="gap:1.25rem;">
          <PlusButton @click="addPackageDialog = false; newProductsPackage = {}">
            {{
              $t("message.cancel")
            }}
          </PlusButton>
          <PlusButton :loading="loadingPackages" intent="primary" @click="addNewProductsPackage()">
            {{ $t("message.products_memberships_plus.add_package") }}
          </PlusButton>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="academyBillDayDialog" width="90%">
      <v-card outlined>
        <v-card-text>
          <v-text-field outlined :label="$t('message.academy_bill_day')" v-model="academyBillDay"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn elevation="0" outlined class="outlined-btn"
            @click="academyBillDayDialog = false; academyBillDay = academy.academyBillDay;">
            {{
              $t("message.cancel")
            }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn outlined elevation="0" color="primary" @click="updateAcademyBillDay()">
            {{ $t("message.update") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <CustomOnboarding ref="productsMembershipsTour" tour-name="products-memberships-onboarding"
      :steps="productsMembershipsTourSteps" :finish-route="null" finish-button-text="GOT IT" />
  </div>

</template>

<script>

import CustomOnboarding from "@/components/onboarding/CustomOnboarding.vue";
import { buildProductsMembershipsTourSteps } from "@/components/onboarding/productsMembershipsTourSteps";
import PlusButton from "@/components/plus/PlusButton";
import Api from "@/services/Api2";
import {
  BookmarkAltIcon,
  CloudDownloadIcon,
  ReceiptTaxIcon
} from '@vue-hero-icons/outline';
import ApexChart from 'vue-apexcharts';

export default {
  components: {
    PlusButton,
    ApexChart,
    CustomOnboarding,
    ReceiptTaxIcon,
    CloudDownloadIcon,
    BookmarkAltIcon
  },
  data() {
    return {
      urlTab: this.$route.params.tabId,
      urlCategory: this.$route.params.category,
      activeTab: 0,
      selectedCategory: [],
      loading: true,
      isConnected: false,
      allowPublicPurchases: false,
      academy: null,
      selectedProduct: null,
      trendline: { data: [], options: null, products: [], loading: false },
      subscriptionTypes: [],
      filterProductsValue: "",
      categories: [],
      academyBillDay: null,
      academyBillDayDialog: false,
      filteredCategories: [],
      packages: [],
      availableProductsForMain: [],
      availableProductsForExtra: [],
      addPackageDialog: false,
      loadingPackages: true,
      newProductsPackage: {},
      categorizedGoods: {},
      subscriptions: [],
      paymentsReady: true,
      goods: [],
      filteredSubscriptions: [],
      memberships: [],
      selectedMembershipType: 1,
      inactive: [],
      hasProducts: false,
      goodsLength: 0,
      filteredGoodsLength: 0,
      managedAcademy: this.$store.state.managedAcademy,
      intervals: [
        { text: this.$t("message.daily"), value: "day" },
        { text: this.$t("message.weekly"), value: "week" },
        { text: this.$t("message.monthly"), value: "month" },
        { text: this.$t("message.yearly"), value: "year" },
      ],
    };
  },
  computed: {
    productsMembershipsTourSteps() {
      return buildProductsMembershipsTourSteps(this);
    },
  },
  mounted() {
    this.tryStartProductsMembershipsTour();
  },
  created() {
    this.checkAcademyStatus();
    if (!this.$store.state.managedAcademy) {
      this.navigateTo({ name: "noacademy" });
      return;
    }
    Api()
      .get("admins/academy/" + this.$store.state.selectedAcademy)
      .then((response) => {
        this.academy = response.data;
        if (!response.data.paymentsReady)
          this.selectedMembershipType = 0;
        this.academyBillDay = response.data.academyBillDay > 0 ? response.data.academyBillDay : 0;
        this.paymentsReady = this.academy.paymentsReady ? this.academy.paymentsReady : false;
        Api()
          .get(
            "admins/academy/" +
            this.$store.state.managedAcademy +
            "/is_connected/all"
          )
          .then((response) => {
            this.isConnected = response.data.stripeConnected;
            if (this.isConnected) {
              if (!this.$store.state.stripeAccountId)
                this.$store.dispatch("setStripeAccountId", response.data.id);
            } else if (response.data.paymentsModule == 'easypay') {
              this.isConnected = true;
            }
            this.loadPage();
          });
      });
  },
  watch: {
    async "$route.fullPath"() {
      await this.$nextTick();
      this.tryStartProductsMembershipsTour();
    },
    filterProductsValue: {
      immediate: false,
      handler: function (newValue) {
        this.fillCategories(newValue);
      },
    },
  },
  methods: {
    stripProductsMembershipsTourQuery() {
      if (this.$route.query.tour !== "true") {
        return;
      }
      const query = { ...this.$route.query };
      delete query.tour;
      this.$router.replace({
        path: this.$route.path,
        query
      }).catch(() => { });
    },
    async tryStartProductsMembershipsTour() {
      if (this._productsMembershipsTourLaunching) {
        return;
      }
      if (this.$route.name !== "productsmemberships" || this.$route.query.tour !== "true") {
        return;
      }

      await new Promise((resolve) => setTimeout(resolve, 1000));

      this._productsMembershipsTourLaunching = true;
      try {
        const appTour = this.$tours && this.$tours["custom-onboarding"];
        if (appTour && typeof appTour.stop === "function") {
          appTour.stop();
        }
        this.$emit("expand-nav-for-tour");
        await this.$nextTick();
        const delayMs = 500;
        await new Promise((resolve) => setTimeout(resolve, delayMs));
        const onboarding = this.$refs.productsMembershipsTour;
        if (onboarding && typeof onboarding.start === "function") {
          await onboarding.start();
        }
        this.stripProductsMembershipsTourQuery();
      } finally {
        this._productsMembershipsTourLaunching = false;
      }
    },
    selectMainPackageProduct(e) {
      this.newProductsPackage.mainProduct = e._id;
      this.newProductsPackage.mainProductObject = e;
      this.fillAvalableExtraProducts();
    },
    fillCategories(value) {
      if (value) value = value.toLowerCase();
      try {
        var count = 0;
        if (this.categories && this.categories.length > 0) {
          this.categorizedGoods["uncategorized"] = [];
          for (const c of this.categories) this.categorizedGoods[c] = [];
          //Now proceed to add all the products
          var tmpCategories = [];
          if (this.goods) {
            this.goodsLength = this.goods.length;
            for (const g of this.goods) {
              if (g.allowPublicPurchase)
                this.allowPublicPurchases = true;
              if (
                !value ||
                value == "" ||
                g.name.toLowerCase().indexOf(value) >= 0
              ) {
                if (g.category) {
                  this.categorizedGoods[g.category].push(g);
                  if (tmpCategories.indexOf(g.category) < 0)
                    tmpCategories.push(g.category);
                } else this.categorizedGoods["uncategorized"].push(g);
                count++;
              }
            }
          }
          this.filteredCategories = tmpCategories.sort();
          if (this.categorizedGoods["uncategorized"].length > 0)
            this.filteredCategories.push("uncategorized");
          this.filteredGoodsLength = count;
          if (this.subscriptions) {
            var filtered = [];
            for (const i of this.subscriptions) {
              if (i.allowPublicPurchase)
                this.allowPublicPurchases = true;
              if (
                !value ||
                value == "" ||
                i.name.toLowerCase().indexOf(value) >= 0
              ) {
                filtered.push(i);
              }
            }
            this.filteredSubscriptions = filtered;
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    loadPage() {
      this.getProducts();
    },
    getProducts() {
      Api()
        .get(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/products/get/categories"
        )
        .then((response) => {
          this.categories = response.data;
          this.categories.push("uncategorized");
          Api()
            .get(
              "admins/academy/" + this.$store.state.managedAcademy + "/products"
            )
            .then((response) => {
              const data = response.data;
              if (data) {
                let memberships = [];
                let goods = [];
                this.subscriptions = data.subscriptions;
                this.availableProductsForMain.push({ header: this.$t("message.automatic_memberships") });
                for (const i of this.subscriptions) {
                  this.availableProductsForMain.push({ taxBehavior: i.taxBehavior, name: i.name, amountDecimal: i.amountDecimal, _id: i._id })
                }
                this.inactive = data.inactive;
                for (const g of data.goods) {
                  if (g.isMembership) {
                    memberships.push(g);
                  } else {
                    goods.push(g);
                  }
                  this.trendline.products.push({
                    text: g.name,
                    value: g._id
                  });
                }
                this.goods = goods;
                this.memberships = memberships;
                this.availableProductsForMain.push({ header: this.$t("message.manual_memberships") });
                for (const i of this.memberships)
                  this.availableProductsForMain.push({ taxBehavior: i.taxBehavior, name: i.name, amountDecimal: i.amountDecimal, _id: i._id })
                this.availableProductsForMain.push({ header: this.$t("message.goods") });
                for (const i of this.goods)
                  this.availableProductsForMain.push({ taxBehavior: i.taxBehavior, name: i.name, amountDecimal: i.amountDecimal, _id: i._id })
                if (this.goods && this.goods.length > 0)
                  this.hasProducts = true;
                this.fillCategories();
                this.loading = false;
                if (this.urlCategory && !isNaN(this.urlCategory)) {
                  this.selectedCategory = [new Number(this.urlCategory).valueOf()];
                }
              }
            })
            .catch((e) => {
              this.loading = false;
              if (e)
                this.showAlert(
                  "error",
                  this.$t("message.error_generic")
                );
            });
        });
    },
    fillAvalableExtraProducts() {
      if (this.newProductsPackage && this.newProductsPackage.mainProductObject) {
        for (const i of this.goods) {
          //Add products to our lists for packages
          let taxMatches = true;
          if (this.newProductsPackage.mainProductObject.taxBehavior && i.taxBehavior != this.mainProductObject.taxBehavior)
            taxMatches = false;
          if (taxMatches) {
            this.availableProductsForExtra.push({ text: i.name, value: i._id, product: i })
          }
        }
      }
    },
    getInventoryColor(amount) {
      if (amount == 0) return "red";
      else if (amount > 0 && amount <= 5) return "orange";
      else return "green";
    },
    getPackages() {
      this.loadingPackages = true;
      Api()
        .get("admins/managedacademy/" + this.$store.state.managedAcademy + "/products/packages")
        .then((response) => {
          this.packages = response.data.data;
          this.loadingPackages = false;
        })
        .catch((e) => {
          if (e) {
            this.showAlert("error", this.$t("message.error_generic"));
          }
        });
    },
    clickCategory() {
      // No-op: expansion panels toggle inline in the Plus UI.
    },
    clickTab(tab) {
      if (tab == 2) {
        this.getPackages();
      }
    },
    addNewProductsPackage() {
      if (!this.newProductsPackage
        || !this.newProductsPackage.name
        || !this.newProductsPackage.description
        || !this.newProductsPackage.mainProduct
        || !this.newProductsPackage.products) {
        this.showAlert("error", this.$t("message.fill_all_parameters"));
        return;
      }
      this.loadingPackages = true;
      Api()
        .post("admins/managedacademy/" + this.$store.state.managedAcademy + "/products/packages", this.newProductsPackage)
        .then(() => {
          this.showAlert("success", this.$t("message.success"));
          this.getPackages();
          this.addPackageDialog = false;
          this.newProductsPackage = {};
        })
        .catch((e) => {
          if (e) {
            this.showAlert("error", this.$t("message.error_generic"));
          }
        });
    },
    getProductTrendline() {
      if (this.selectedProduct) {
        this.trendline.loading = true;
        this.trendline.data = [];
        Api()
          .get(
            "payments/academy/" + this.$store.state.managedAcademy + "/product/" + this.selectedProduct + "/transactions/trendline"
          )
          .then((response) => {
            const data = response.data.data;
            let categories = [];
            let series = [];
            if (data.length > 0) {
              const productName = response.data.product;
              let keys = {};
              for (const i of data) {
                const monthString = this.$d(new Date(i.date), "month_day", this.$i18n.locale);
                keys[i.key] = {
                  date: monthString,
                  count: i.count
                };
              }
              let today = new Date();
              let firstDay = new Date(data[0].date);
              //loop over all days
              for (let d1 = new Date(firstDay); d1 <= today; d1.setDate(d1.getDate() + 1)) {
                const key =
                  d1.getFullYear() +
                  "-" +
                  (new Number(d1.getMonth()).valueOf() + 1) +
                  "-" +
                  d1.getDate();
                const monthString = this.$d(new Date(d1), "month_day_year", this.$i18n.locale);
                categories.push(monthString)
                const v = keys[key];
                if (v) {
                  series.push(v.count);
                } else {
                  series.push(0);
                }
              }

              this.trendline.data = [{
                name: productName,
                data: series
              }];
              this.trendline.options = {
                colors: [this.themeColor('primary')],
                xaxis: {
                  categories: categories,
                  type: 'datetime',
                  labels: {
                    show: true,
                  }
                },
                yaxis: {
                  labels: {
                    show: true,
                    formatter: function (val) {
                      return val.toFixed(0);
                    }
                  }
                },
                dataLabels: {
                  enabled: false,
                },
                stroke: {
                  curve: 'smooth'
                },
                theme: {
                  mode: this.isDarkMode() ? 'dark' : 'light',
                },
                chart: {
                  toolbar: {
                    show: false
                  },
                  background: 'none'
                },
                legend: {
                  show: false
                },
                grid: {
                  show: false
                },
              };
            }
            this.trendline.loading = false;
          })
          .catch((err) => {
            console.log(err)
            this.trendline.loading = false;
          });
      } else {
        this.trendline.loading = false;
        this.trendline.data = [];
      }
    },
    showEditBillDayDialog() {
      this.academyBillDayDialog = true;
    },
    updateAcademyBillDay() {
      const data = [
        {
          propName: 'academyBillDay',
          value: this.academyBillDay,
        },
      ];
      Api()
        .patch("admins/academy/" + this.$store.state.selectedAcademy, { values: data, })
        .then((response) => {
          const data = response.data;
          if (data) {
            this.showAlert("success", this.$t("message.updated"));
            this.academyBillDayDialog = false;
          }
        })
        .catch((e) => {
          if (e) {
            this.showAlert("error", this.$t("message.error_generic"));
          }
        });
    },
    goToPackage(p) {
      this.navigateTo({ name: "manageproductspackageplus", params: { packageId: p._id }, });
    },
    getProductsCSV() {
      Api()
        .get(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/products/export/csv"
        )
        .then((response) => {
          let blob = new Blob([response.data], { type: "text/csv" });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download =
            this.academy.name +
            "_Products_" +
            new Date().toISOString() +
            "_" +
            ".csv";
          link.click();
        })
        .catch((e) => {
          if (e)
            this.showAlert("error", this.$t("message.error_generic"));
        });
    },
  }
}

</script>

<style scoped>
.v-expansion-panel {
  border: 1px solid #E0E0E0;
}

.currency-widget {
  border: 1px solid var(--v-plusBorder-base);
}

/* Header icon SVG ships with hardcoded dark fills (#212121); inverting in
   dark mode flips them to white so the icon stays visible against the
   dark background without modifying the asset itself. */
.header-icon {
  width: 24px;
  height: 24px;
}

.theme--dark .header-icon {
  filter: invert(1);
}

.empty-state-icon {
  width: 160px;
  height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.empty-state-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>
